import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [error, setError] = useState('');
  const location = useLocation();

  // Check for SAML error or logout success in URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const samlError = searchParams.get('error');
    const logoutSuccess = searchParams.get('logout');
    
    if (logoutSuccess === 'success') {
      // Optionally show a success message for logout
      // For now, we'll just clear any previous errors
      setError('');
    } else if (samlError) {
      const errorMessages = {
        'no_neptun_code': 'Nem található Neptun kód az egyetemi fiókhoz.',
        'not_authorized': 'Nincs jogosultsága a rendszerhez. Kérem vegye fel a kapcsolatot az adminisztrátorral.',
        'user_not_initialized': 'A fiókja még nincs inicializálva. Kérem először jelentkezzen be jelszóval, vagy vegye fel a kapcsolatot az adminisztrátorral.',
        'saml_processing_error': 'Hiba történt a bejelentkezés feldolgozása során.',
        'no_credentials': 'Nem található Neptun kód vagy törzsszám az egyetemi fiókhoz.'
      };
      
      setError(errorMessages[samlError] || 'Ismeretlen hiba történt a bejelentkezés során.');
    }
  }, [location]);

  const handleShibbolethLogin = () => {
    // Redirect to backend SAML login endpoint
    const backendUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
    window.location.href = `${backendUrl}/login`;
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img 
          src="/sze_logo_full-ByPIlbSP.png" 
          alt="SZE Logo" 
          className="sze-logo"
        />
        <h2>E-Szakjelentés alkalmazás</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        {/* Shibboleth Login Button */}
        <button 
          onClick={handleShibbolethLogin}
          className="shibboleth-login-button"
          type="button"
        >
          Bejelentkezés egyetemi fiókkal
        </button>

        <p className="login-info">
          A belépéshez használja egyetemi azonosítóját.
        </p>
      </div>
    </div>
  );
};

export default Login;
